import { Model } from '@vuex-orm/core'
import QuestionCategory from './QuestionCategory'
import Language from './Language'

export default class Question extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'question'

  static primaryKey = '_id'

  // List of all fields (schema) of the model. `this.attr` is used for the generic field type.
  // The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      customer: this.attr(null),
      category_id: this.attr(null),
      category: this.belongsTo(QuestionCategory, 'category_id'),
      title: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      text: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      minimumText: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      maximumText: this.attr([
        new Language('en'),
        new Language('de')
      ]),
      type: this.attr('slider'),
      createdAt: this.attr('')
    }
  }

  static defaults (langs) {
    return Object.assign(this, {
      title: langs.map( lang => new Language(lang) ),
      text: langs.map( lang => new Language(lang) ),
      minimumText: langs.map( lang => new Language(lang) ),
      maximumText: langs.map( lang => new Language(lang) )
    })
  }

  static apiConfig = {}
}